var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-button', _vm._b({ staticClass: "download-btn", on: { "click": _vm.download } }, 'el-button', _vm.innerConfig, false), [_vm._v(_vm._s(_vm.text))]);
};
var staticRenderFns = [];

export { render, staticRenderFns };